import { render, staticRenderFns } from "./CadastroRegra.vue?vue&type=template&id=a1373686&scoped=true&class=template&"
import script from "./CadastroRegra.vue?vue&type=script&lang=js&"
export * from "./CadastroRegra.vue?vue&type=script&lang=js&"
import style0 from "./CadastroRegra.vue?vue&type=style&index=0&id=a1373686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1373686",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCol,VRow})
